import { baseApi } from "./base.api";

export const unitsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchUnits: build.query({
      query: (params) => ({ url: "/units/fetch", method: "GET", params }),
      providesTags: ["Unit"],
    }),
    fetchTrashedUnits: build.query({
      query: (params) => ({ url: "/units/fetch/trashed", method: "GET", params }),
      providesTags: ["Unit"],
    }),
    fetchUnitsAll: build.query({
      query: () => ({ url: "/units/fetch/all", method: "GET" }),
      providesTags: ["Unit"],
    }),
    fetchUnitById: build.query({
      query: (id) => ({ url: `/units/fetch/${id}`, method: "GET" }),
      providesTags: ["Unit"],
    }),
    fetchUnitByDistrict: build.query({
      query: (id) => ({ url: `/units/district/${id}`, method: "GET" }),
      providesTags: ["Unit"],
    }),
    createUnit: build.mutation({
      query: (body) => ({ url: "/units/create", method: "POST", body }),
      invalidatesTags: ["Unit"],
    }),
    updateUnit: build.mutation({
      query: ({ id, body }) => ({ url: `/units/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Unit"],
    }),
    restoreUnit: build.mutation({
      query: (id) => ({ url: `/units/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Unit"],
    }),
    bulkRestoreUnits: build.mutation({
      query: (body) => ({ url: "/units/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Unit"],
    }),
    deleteUnit: build.mutation({
      query: (id) => ({ url: `/units/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Unit"],
    }),
    bulkDeleteUnits: build.mutation({
      query: (body) => ({ url: "/units/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Unit"],
    }),
    destroyUnit: build.mutation({
      query: (id) => ({ url: `/units/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Unit"],
    }),
    bulkDestroyUnits: build.mutation({
      query: (body) => ({ url: "/units/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Unit"],
    }),
  }),
});

export const {
  useFetchUnitsQuery,
  useFetchTrashedUnitsQuery,
  useFetchUnitByIdQuery,
  useCreateUnitMutation,
  useUpdateUnitMutation,
  useRestoreUnitMutation,
  useBulkRestoreUnitsMutation,
  useDeleteUnitMutation,
  useFetchUnitsAllQuery,
  useFetchUnitByDistrictQuery,
  useBulkDeleteUnitsMutation,
  useDestroyUnitMutation,
  useBulkDestroyUnitsMutation,
} = unitsApi;
